import { Api } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';

class ActionReputationDetailsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async createActionReputationDetails(
    id: string,
    body: { action: 'Share' | 'Dispute' | 'Dismissed'; actionNotes: string }
  ) {
    return super.write<{ data: null }>({
      endpoint: `/actionReputationDetails/${id}`,
      body,
      method: 'POST',
    });
  }
}

export const ActionReputationDetailsApi = new ActionReputationDetailsApiClass();
